import { Timestamp } from 'firebase/firestore';
import { IFutureOrder } from '../../sp-types/FutureOrderType';
import { MonthYear } from '../../utils/MonthYear/monthYear';

export const BACK_TO_BACK_SUMMARY_ROUTE = 'back-to-back-summary';
export const INDEXED_SUMMARY_ROUTE = 'indexed-order-summary';

export const mockFutureOrder = (): IFutureOrder => ({
  orderId: '1500_' + new Date().getTime(),
  futureOrderDate: Timestamp.fromDate(new Date(2024, 0)),
  clientName: 'SteelX',
  productId: 'Srp1',
  status: 'completed',
  orderDetails: {
    deliveryDates: [
      { month: 1, year: 2024 },
      { month: 10, year: 2024 },
    ],
    deliveryType: 'Monthly',
    productDeliveryCalendar: [],
    quantity: 2446,
    pricePerUnit: 2050,
  },
  clientExposure: {},
  supplierExposure: [],
  fileUrl: [],
  updatedAt: Timestamp.now(),
});

export const emptyFutureOrder: IFutureOrder = {
  orderId: '',
  productId: '',
  orderDetails: {
    deliveryDates: [],
    deliveryType: '',
    productDeliveryCalendar: [],
    quantity: 0,
  },
  clientExposure: {},
  supplierExposure: [],
  totalExposure: [],
  fileUrl: [],
  comments: [],
  status: 'underwriting',
  updatedAt: Timestamp.now(),
};

export const getOrderSummaryRoute = (futureOrderType: 'BackToBack' | 'Indexed'): string =>
  futureOrderType === 'Indexed' ? INDEXED_SUMMARY_ROUTE : BACK_TO_BACK_SUMMARY_ROUTE;

export const isBefore = (a: MonthYear, { month, year }: MonthYear): boolean =>
  a.year < year || (a.year === year && a.month < month);

export const getDateAfter = ({ month, year }: MonthYear, months: number): MonthYear => ({
  year: year + months / 12,
  month: (month + months) % 12,
});
